import React, { useEffect, useState } from 'react'
import { CreatePendencyLayout } from 'presentation/hospital/layouts/CreatePendency'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteLoadSurgicalOrder } from 'service/usecases/load-surgical-order/remote-load-surgical-order'
import { useLocation } from 'react-router'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { toast } from 'react-toastify'

type SurgicalLocation = {
  id: number
}

const CreatePendency = WithLoading(({ setIsLoading }: WithLoadingProps) => {
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )

  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)
  const loadSurgicalOrder = new RemoteLoadSurgicalOrder(surgicalOrderRepository)
  const location = useLocation<SurgicalLocation>()
  const [order, setOrder] = useState({} as SurgicalOrderModel)

  async function loadData() {
    setIsLoading(true)
    try {
      const loadOrder = await loadSurgicalOrder.load(
        Number(location.state.id),
        [
          `
          surgical_order_id,
          status {
            status
          },
          doctor {
            doctor_id,
            name,
            phone,
            email,
            crm,
            secretary {
              secretary_id,
              name,
              phone,
              email,
              user_id
            }
          },
          patient {
            patient_id,
            name,
            phone,
            email,
            cpf,
          },
          hospital {
            hospital_id,
            name
          }
          `
        ]
      )
      setOrder(loadOrder)
    } catch (error: any) {
      toast.error('Ocorreu um erro ao carregar o pedido cirúrgico')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  return <CreatePendencyLayout surgicalOrder={order} />
})

export default CreatePendency
